import 'regenerator-runtime';
import './index.css';
import { EventBus, EventTypes } from './consts/const-event-types';
import 'lazysizes';

/*
To add new components, import them here and add them to the 'components'-array below.
Add an appropriate selectorName for use in DOM (fx: <div data-component="header"></div>):
*/
import App from './components/app';
import ExampleComponent from './components/example-component/example-component';
import UserItem from './components/user-item/user-item';
import BurgerMenu from './components/burger-menu/burger-menu';
import DesktopMenu from './components/desktop-menu/desktop-menu';
const components = [
  { Class: App, selectorName: 'app' },
  { Class: ExampleComponent, selectorName: 'example-component' },
  { Class: UserItem, selectorName: 'user-item' },
  { Class: BurgerMenu, selectorName: 'burger-menu' },
  { Class: DesktopMenu, selectorName: 'desktop-menu' },
];

/*
 * ComponentInstantiator traverses the DOM-tree and looks for [data-component='] attributes.
 */
class ComponentInstantiator {
  constructor() {
    this.createComponents();
    this.dispatchReady();
    return this;
  }

  createComponents() {
    this.componentsInstantiated = {};

    components.map(component => {
      const nodes = [];
      // select all DOM-nodes with the data-component attribute:
      const nodeItems = [...document.querySelectorAll("[data-component='" + component.selectorName + "']")];

      nodeItems.map(nodeItem => {
        // instantiate component with nodeItem as param:
        nodes.push(new component.Class(nodeItem));
      });

      // add to componentsList object:
      if (nodes.length) this.componentsInstantiated[component.selectorName] = nodes;
    });
  }

  dispatchReady() {
    const event = new CustomEvent(EventTypes.ALL_COMPONENTS_READY);
    EventBus.dispatchEvent(event);
  }

  getComponents(selectorName) {
    return selectorName ? this.componentsInstantiated[selectorName] : this.componentsInstantiated;
  }
}

/* Make your App accessible via window.App */
window.App = new ComponentInstantiator();

/* Access components list */
// console.log('components on this page', window.App.getComponents())
